<template>
  <v-menu
      v-if="$store.state.permissions['operadores:read'] && $util.isRol('OPERADOR')"
      v-model="menu"
      offset-x
      :close-on-content-click="false"
      max-width="320"
      min-width="320"
    >
    <v-toolbar-title slot="activator">
      <v-tooltip bottom v-if="tiene_cubiculo_seleccionado">
        <template v-slot:activator="{ on }">
          <v-chip label color="success" text-color="white" v-on="on">
            {{ $store.state.cubiculo.identificador }}
          </v-chip>
        </template>
        <span>{{ $t('operadores.cubiculo.cambiar') }}</span>
      </v-tooltip>
      <v-tooltip bottom v-if="!tiene_cubiculo_seleccionado">
        <v-btn icon slot="activator">
          <v-icon>dashboard</v-icon>
        </v-btn>
        <span>{{ $t('operadores.cubiculo.iniciar') }}</span>
      </v-tooltip>
    </v-toolbar-title>
    <v-card>
      <v-container grid-list-md class="menu-operador">
        <v-layout wrap v-if="tiene_cubiculo_seleccionado">
          <v-flex xs12>
            <h3>{{$store.state.cubiculo.identificador}}</h3>
            <v-btn color="success" @click.native.stop="ingresar($store.state.cubiculo)">
              <v-icon>chat</v-icon> &ensp;ingresar
            </v-btn>
          </v-flex>
          <v-tooltip bottom>
            <v-btn color="primary" icon @click.native.stop="salir()" absolute right slot="activator">
              <v-icon>&#xE8AC;</v-icon>
            </v-btn>
            <span>{{ $t('operadores.cubiculo.salir') }}</span>
          </v-tooltip>
        </v-layout>
        <v-layout wrap v-else>
          <v-flex xs12>
            <h3>{{ $t('operadores.cubiculo.iniciar') }}</h3>
          </v-flex>
        </v-layout>
      </v-container>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" v-for="(cubiculo, index) in cubiculos" v-bind:key="index" @click.native.stop="ingresar(cubiculo)">
          {{cubiculo.identificador}}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import Auth from '@/components/admin/auth/mixins/auth';
export default {
  mixins: [ Auth ],
  created () {
    this.user = this.$storage.getUser();
    this.idEntidad = this.user.id_entidad;
  },
  data () {
    return {
      menu: false,
      tiene_cubiculo: 0,
      cubiculo_actual: {},
      cubiculos: []
    };
  },
  computed: {
    tiene_cubiculo_seleccionado () {
      return this.$store.state.cubiculo.id > 0;
    }
  },
  mounted () {
    this.tiene_cubiculo = this.$store.state.cubiculo.id > 0 ? this.$store.state.cubiculo.id : 0;
    this.cubiculo_actual = this.$store.state.cubiculo;

    if (`${this.tiene_cubiculo}` === `0`) {
      this.tiene_cubiculo = this.$storage.get('cubiculo');
      this.cubiculo_actual = this.$storage.get('cubiculo_actual') || {};
    }
    if (this.tiene_cubiculo > 0) {
      this.$store.commit('cubiculo', this.cubiculo_actual);
    }
    if (this.$store.state.permissions['operadores:read']) {
      this.recuperarPuntosAtencion();
    }
  },
  methods: {
    recuperarPuntosAtencion () {
      this.cubiculos = [];
      this.$service.get(`system/operadores/cubiculos`, {})
      .then(response => {
        if (response) {
          response.forEach((item) => {
            this.cubiculos.push(item);
          });
        }
      });
    },
    ingresar (cubiculo) {
      if (this.$store.state.cubiculo.id !== cubiculo.id && this.$store.state.cubiculo.id > 0) {
        this.$confirm(`¿Está seguro de dejar el Punto de Atención e Iniciar en otro Punto de Atención?`, () => {
          this.cubiculo_actual = cubiculo;
          this.tiene_cubiculo = cubiculo.id;
          this.$storage.set('cubiculo', cubiculo.id);
          this.$storage.set('cubiculo_actual', cubiculo);
          this.$store.commit('cubiculo', this.cubiculo_actual);
          this.recordLogin();
          this.reload();
          this.$router.push(`/chat/${cubiculo.id}`);
          this.menu = false;
        });
      } else {
        if (this.tiene_cubiculo !== cubiculo.id) {
          this.tiene_cubiculo = cubiculo.id;
          this.cubiculo_actual = cubiculo;
          this.$storage.set('cubiculo', cubiculo.id);
          this.$storage.set('cubiculo_actual', cubiculo);
          this.$store.commit('cubiculo', this.cubiculo_actual);
          this.recordLogin();
          this.reload();
        }
        this.$router.push(`/chat/${cubiculo.id}`);
        this.menu = false;
      }
    },
    salir () {
      this.$confirm(`¿Está seguro de dejar el Punto de Atención?`, () => {
        this.tiene_cubiculo = 0;
        this.$storage.set('cubiculo', 0);
        this.$store.commit('cubiculo', {id: 0});
        this.recordLogOut();
        this.reload();
        this.menu = false;
        this.tiene_cubiculo_seleccionado = false;
      });
    },
    recordLogin () {
      if (this.user && this.cubiculo_actual && this.cubiculo_actual.id) {
        this.$service.put(`system/historial_punto_atencion/ingreso`, { id_punto_atencion: this.cubiculo_actual.id })
        .then(response => {
          if (response) {
            console.log(response);
            // this.$message.success(`Caso guardado exitosamente!`, null, { timeout: 2000 });
          }
        });
      }
    },
    recordLogOut () {
      if (this.user) {
        this.$service.put(`system/historial_punto_atencion/salida`, {})
        .then(response => {
          if (response) {
            console.log(response);
            // this.$message.success(`Caso guardado exitosamente!`, null, { timeout: 2000 });
          }
        });
      }
    }
  }
};
</script>

<style lang="scss">
@import '../../assets/scss/_variables.scss';
.menu-operador {
  color: lighten($warning, 10%);
  font-size: 1rem;
  padding: 10px 15px;
  background-color: darken($info, 5%);
  background-image: url(../../assets/images/bg.png);
  background-position: center;
  background-size: cover;

  h3 {
    font-size: 1.3rem;
    color: white;
    font-weight: 400;
  }

  .v-icon {
    color: white !important;
    font-size: 1.1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/layout/AppOperador.vue